import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import instance from "../../api/api";
import { useDispatch } from "react-redux";
import {showModal} from "../../store/slice/PrintSlice"

import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { Header, LoadingSpinner, InfoDetails,ModalDelete } from "../../shared/compoments";
import {Help} from "../../utils"



function DetailRequete() {

  const { id } = useParams();
  const dispatch = useDispatch();
  const [detailRequete, setDetailRequete] = useState(null);
  const [isLoadingDelete,setIsLoadingDelete]=useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [detailInfo, setDetailInfo] = useState([]);
  const [isRejectedBtn,setIsRejectedBtn] = useState(false);
  const [valueTextField,setValueTextField] = useState("")
  const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Confirmer",
      icone: <CheckIcon />,
      isColor:true,
       isVisible:detailRequete && (detailRequete.statut === 'en attente' ||
         detailRequete.statut === 'en cours') ? true:false ,
      backgroundColor:'#4bd04b',
      methode: () => {
        setIsRejectedBtn(false)
        dispatch(showModal())
      },
    },
    {
      titleBtn: "Rejeter",
      icone: <ClearIcon />,
      isColor:true,
      isVisible:detailRequete && (detailRequete.statut === 'en attente' ||
         detailRequete.statut === 'en cours') ? true:false,
      backgroundColor:'crimson',
      methode: () => {
         setIsRejectedBtn(true)
         dispatch(showModal())
        console.log("rejeter");
      },
    },
  ];
  const dataInfoDetail = (
    created_at,
    date_activite,
    description,
    localisation,
    prix,
    propriety,
    statut,
    type,
    type_reque,
    budget_client,
    commentaire
  ) => {
    const element = [];
    element.push(
      { title: "DATE D'ENREGISTREMENT", value: Help.convertDate(created_at) },
      { title: "STATUT", value: statut },
      { title: "CATEGORIE DE DEMANDE", value: type_reque },
      { title: "DATE DE DISPONIBILITE DU BIEN", value: date_activite },
      { title: "RESSOURCES FINANCIÈRES DU CLIENT", value: budget_client },
      { title: "DETAIL DE LA DEMANDE", value: description },
      { title: "ADRESSE DU BIEN", value: localisation },
      { title: "PRIX DU BIEN (FCFA)", value: Help.convertInMoney(prix) },
      { title: "BIEN", value: propriety?.nom },
      { title: "TYPE DE BIEN", value: type?.label },
      { title: "COMMENTAIRE", value: commentaire }
      
    );
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };
  const handleChangeRejectWithTextField=(e)=>{
    setValueTextField(e.target.value)
  }
  const changeStatut = async (statut,commentaire=null)=>{
     setIsLoadingDelete(true)
   try{
    const response = await instance.put("requetes/"+id,{
      statut: statut,
      commentaire:commentaire
    });
    console.log("response",response)
    console.log(response)
      if (response.data.status) {
          detailRequete.statut = statut
          detailRequete.commentaire = commentaire
          console.log("detailRequete",detailRequete)
          dispatch(showModal())
      }
      setIsLoadingDelete(false)
   }catch(error){
    console.log(error);
     setIsLoadingDelete(false)
   }
  }
  const getdetailRequete = async () => {
      try {
        const response = await instance.get(`requetes/${id}`);
        console.log("getdetailRequete", response);
        setDetailRequete(response.data.data);
        const {
          created_at,
          date_activite,
          description,
          localisation,
          prix,
          propriety,
          statut,
          type,
          type_reque,
          budget_client,
          commentaire
        } = response.data.data;
        dataInfoDetail(
          created_at,
          date_activite,
          description,
          localisation,
          prix,
          propriety,
          statut,
          type,
          type_reque,
          budget_client,
          commentaire
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };

  useEffect(() => {
    const getdetailRequete = async () => {
      try {
        const response = await instance.get(`requetes/${id}`);
        console.log("getdetailRequete", response);
        setDetailRequete(response.data.data);
        const {
          created_at,
          date_activite,
          description,
          localisation,
          prix,
          propriety,
          statut,
          type,
          type_reque,
          budget_client,
          commentaire
        } = response.data.data;
        dataInfoDetail(
          created_at,
          date_activite,
          description,
          localisation,
          prix,
          propriety,
          statut,
          type,
          type_reque,
          budget_client,
          commentaire
        );
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getdetailRequete();
  }, [id]);

  if (isLoading) return <LoadingSpinner />;
  return (
    <div>
      <ModalDelete   
      modalTitle={"Êtes-vous sûr ?"} 
      isPrintFacture={false}
      isRejectedBtn={isRejectedBtn}
      valueTextField={valueTextField}
      handleChangeRejectWithTextField={handleChangeRejectWithTextField}
      dataInfoForBtn={
        [{
          libelleBtn:isLoadingDelete ? 'Loading...':'Oui',
          color:"error",
          methode:()=>{
            if(isRejectedBtn){
              changeStatut('refuse',valueTextField)
            }
            if(!isRejectedBtn){
              changeStatut('accepter')
            }
            getdetailRequete()
          }
        },{
          libelleBtn:"Non",
          isStyle:true,
          methode:()=>{
            dispatch(showModal())
          }
        }]
      }
      />
      {detailRequete && (
        <>
          <Header libelle={"Détails requête"} isReturn />
          <InfoDetails
            namePerson={`${detailRequete.nom_client} ${detailRequete.prenom_client}`}
            detailPhone={detailRequete.contact_client}
            detailAdresse={""}
            widthBody={"70%"}
            titleInfo={"Informations de la requête"}
            dataInfo={detailInfo}
            dataBtnWithOptions={DATA_BTN_WITH_CONTRAT_OPTIONS}
          />
        </>
      )}
    </div>
  );
}

export default DetailRequete;
